module.exports = __webpack_public_path__ + "static/media/replayVideo.bd4d3e68.svg";